/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_FREELANCER_REPORT,
  LOAD_FREELANCER_REPORT_SUCCESS,
  LOAD_FREELANCER_REPORT_ERROR,

  UPDATE_FREELANCER_SCHEDULE,
  UPDATE_FREELANCER_SCHEDULE_SUCCESS,
  UPDATE_FREELANCER_SCHEDULE_ERROR,

} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(freelancerMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    freelancerMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}


//permission list
export function loadFreelancerReport(searchvalue) {
  return {
    type: LOAD_FREELANCER_REPORT,
    searchvalue,
  }
}
export function loadFreelancerReportSuccess(freelancer_report) {
  return {
    type: LOAD_FREELANCER_REPORT_SUCCESS,
    freelancer_report,
  }
}
export function loadFreelancerReportError(error) {
  return {
    type: LOAD_FREELANCER_REPORT_ERROR,
    error,
  }
}

//update Freelancer Schedule list
export function updateFreelancerSchedule(updateFreelancer) {
  return {
    type: UPDATE_FREELANCER_SCHEDULE,
    updateFreelancer,
  }
}
export function updateFreelancerScheduleSuccess(updateFreelancer) {
  return {
    type: UPDATE_FREELANCER_SCHEDULE_SUCCESS,
    updateFreelancer,
  }
}
export function updateFreelancerScheduleError(error) {
  return {
    type: UPDATE_FREELANCER_SCHEDULE_ERROR,
    error,
  }
}


const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadFreelancerReport,
  loadFreelancerReportSuccess,
  loadFreelancerReportError,

  //update Freelancer Schedule list
  updateFreelancerSchedule,
  updateFreelancerScheduleSuccess,
  updateFreelancerScheduleError,

}

export default actions
